import React from 'react';
import PropTypes from 'prop-types';
import { ShellPanel } from 'web-ui-components/lib/layout/content';
import { StandardValue } from 'web-ui-components/lib/typography/values';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { ShellInnerSpacer } from 'web-ui-components/lib/layout/shells';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';

export const LiveChatTile = ({ content, initiateChat }) => (
  <ShellPanel>
    <SectionHeading>
      <span>{content.genericChatHeading}</span>
    </SectionHeading>
    <NavigationButton.Secondary
      labelText={content.genericChatButtonText}
      onClick={initiateChat}
    />
    <StandardValue>{content.genericChatDescription}</StandardValue>
    <ShellInnerSpacer />
  </ShellPanel>
);

LiveChatTile.propTypes = {
  content: PropTypes.object,
  initiateChat: PropTypes.func,
};
